import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorefrontService } from '../../../storefront/storefront.service';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { appLanguages, getSelectedDisplayLangName, getSelectedWatchLang, getSelectedWatchLangName } from '../../utils/LanguageUtils';
import { LocalStorageService } from '../local-storage/local-storage.service';

// * This service is used to change the language of the app, that is way needs to be in the root. Otherwise, it will create diferrents variables for each module.
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private languageChangeObservable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(@Inject(DOCUMENT) private document: any, private translate: TranslateService, private storefrontService: StorefrontService, private localStorage: LocalStorageService) {
    this.translate.setDefaultLang('en');
  }

  get language() {
    return appLanguages;
  }

  getObservable(): Observable<boolean> {
    return this.languageChangeObservable.asObservable();
  }

  propagateChange(loadTabs: boolean): void {
    this.languageChangeObservable.next(loadTabs);
  }

  tempChangeLanguage(language: string): void {
    this.translate.use(this.getKeyByValue(language));
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
    this.localStorage.setItem(LocalStorageKeys.LANG, lang);
    this.document.body.classList.remove('-en', '-tg', '-tm');
    this.document.body.classList.add(`-${lang}`);
  }

  changeWatchLanguage(lang: string): void {
    if (getSelectedWatchLang(this.localStorage) !== lang) {
      this.localStorage.setItem(LocalStorageKeys.WATCH_LANG, lang);
      this.storefrontService.initialiseServices();
    }
  }

  getCurrentWatchLanguage(): string {
    return getSelectedWatchLangName(this.localStorage);
  }

  getCurrentLanguage(): string {
    return getSelectedDisplayLangName(this.localStorage);
  }

  getKeyByValue(value: string) {
    return Object.keys(this.language).find((key) => this.language[key] === value);
  }

  getLanguage(lg: string): string {
    return this.language[lg] || '';
  }
}
